import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { Button, debounce, InputAdornment, TextField } from '@mui/material';
import { ChangeEvent, useCallback, useMemo } from 'react';

export type PortalioProposalsSearchProps = {
  onChange: (value: string) => void;
  placeholder?: string;
};

export const ImportProposalsSearch = (props: PortalioProposalsSearchProps) => {
  const onSearchInputChange = useMemo(
    () =>
      debounce((e: ChangeEvent<HTMLInputElement>) => {
        props.onChange(e.target.value?.toLowerCase() ?? '');
      }, 200),
    [props],
  );

  const onClearInput = useCallback(() => {
    props.onChange('');
  }, [props]);

  return (
    <TextField
      autoFocus
      autoComplete="off"
      variant="outlined"
      size="small"
      fullWidth
      placeholder={props.placeholder ?? 'Search proposals...'}
      onChange={onSearchInputChange}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <Button
                variant="text"
                onClick={onClearInput}
                startIcon={<CloseIcon />}
                sx={{
                  minWidth: '0',
                  '& .MuiButton-startIcon': {
                    margin: 0,
                  },
                }}
              />
            </InputAdornment>
          ),
        },
      }}
    />
  );
};
